import { createBrowserRouter } from 'react-router';
import { lazy } from 'react';
import { PROTECTED_PATHS, UNPROTECTED_PATHS, CommonPaths } from './paths';
import GuestGuard from '../guards/GuestGard';
import AuthGuard from '../guards/AuthGard';
import Layout from '../layouts/Layout';
import PublicLayout from '../layouts/PublicLayout';

// Lazy loaded components
const ChildProgressPage = lazy(() => import('../features/child-progress/pages/ChildProgressPage'));
const ChildrenPage = lazy(() => import('@/features/children/pages/ChildrenPage'));
const LoginPage = lazy(() => import('../features/auth/pages/LoginPage'));
const CorrectionResult = lazy(() => import('../features/exercises-correction/pages/CorrectionResultPage'));

// Protected Pages (from screens index)
const ExercisesCorrectionPage = lazy(() => import('../features/exercises-correction/pages/SubjectSelectorPage'));
const ChapterSelectorPage = lazy(() => import('../features/exercises-correction/pages/ChapterSelectorPage').then(m => ({ default: m.ChapterSelectorPage })));
const ExerciseSelectorPage = lazy(() => import('../features/exercises-correction/pages/ExerciseSelectorPage').then(m => ({ default: m.ExerciseSelectorPage })));
/**
 * 懒加载 ExamsSubjectsPage 组件。yarn 
 * 动态导入 '@/features/exam/pages' 模块，并将其中的 ExamsSubjectsPage
 * 作为默认导出返回，便于与 React.lazy 配合使用，实现按需加载以降低首屏体积。
 * 使用时请确保目标模块导出了 ExamsSubjectsPage，并在外层配合 <Suspense>。
 */
const ListSubjectExams = lazy(() => import('@/features/exam/pages').then(m => ({ default: m.ExamsSubjectsPage })));
const ListExamsPage = lazy(() => import('@/features/exam/pages').then(m => ({ default: m.ExamsListPage })));
const ExamPdfPage = lazy(() => import('@/features/exam/pages').then(m => ({ default: m.ExamPdfPage })));
const ChatSupport = lazy(() => import('../screens/ChatSupport'));
const AddChild = lazy(() => import('../features/children/pages/AddChildPage'));
const StorePage = lazy(() => import('../features/store/pages/StorePage').then(m => ({ default: m.StorePage })));

// Common Pages
const NotFound = lazy(() => import('../screens/NotFound'));
const Splash = lazy(() => import('../screens/Splash'));
const ChildReport = lazy(() => import('../screens/ChildReport'));
const PurchaseSuccess = lazy(() => import('../features/store/pages/PurchaseSuccessPage'));
const PurchaseFailure = lazy(() => import('../features/store/pages/PurchaseFailurePage'));
const PrivacyPolicy = lazy(() => import('../screens/PrivacyPolicy'));
const TermsOfService = lazy(() => import('../screens/TermsOfService'));


export const router = createBrowserRouter([
  {
    Component: AuthGuard,
    children: [
      {
        path: '/',
        Component: Layout,
        children: [
          {
            path: PROTECTED_PATHS.childProgress,
            Component: ChildProgressPage,
          },

          {
            path: PROTECTED_PATHS.EXERCISES_CORRECTION.pattern,
            Component: ExercisesCorrectionPage,
          },
          {
            path: PROTECTED_PATHS.CORRECTION_CHAPTERS.pattern,
            Component: ChapterSelectorPage,
          },
          {
            path: PROTECTED_PATHS.EXERCISES_CORRECTION_LIST.pattern,
            Component: ExerciseSelectorPage,
          },
          {
            path: PROTECTED_PATHS.CORRECTION_RESULT.pattern,
            Component: CorrectionResult,
          },

          // Exams
          {
            path: PROTECTED_PATHS.ListSubjectExams,
            Component: ListSubjectExams,
          },
          {
            path: PROTECTED_PATHS.ListExams,
            Component: ListExamsPage,
          },
          {
            path: PROTECTED_PATHS.Exampdf,
            Component: ExamPdfPage,
          },

          // Chat
          {
            path: PROTECTED_PATHS.chatSupport,
            Component: ChatSupport,
          },
          {
            path: PROTECTED_PATHS.store,
            Component: StorePage,
          },


          {
            path: CommonPaths.notFound,
            Component: NotFound,
          },
          {
            path: CommonPaths.splash,
            Component: Splash,
          },
        ]
      },
      {
        path: PROTECTED_PATHS.children,
        Component: ChildrenPage,
      },
      {
        path: PROTECTED_PATHS.addChild,
        Component: AddChild,
      },
    ]
  },
  {
    Component: GuestGuard,
    children: [
      {
        path: UNPROTECTED_PATHS.login,
        Component: LoginPage,
      },
    ],
  },
  {
    path: CommonPaths.childReport,
    Component: ChildReport,
  },
  {
    path: CommonPaths.purchaseSuccess,
    Component: PurchaseSuccess,
  },
  {
    path: CommonPaths.purchaseFailure,
    Component: PurchaseFailure,
  },
  {
    path: '/',
    Component: PublicLayout,
    children: [
      {
        path: CommonPaths.privacyPolicy,
        Component: PrivacyPolicy,
      },
      {
        path: CommonPaths.termsOfService,
        Component: TermsOfService,
      }
    ]
  }
]);
